import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';

import { actions as cityGuideActions } from '../../appstate/placeGuide';
import { getCityGuide } from '../../services/seoService';
import SLICE_NAMESPACE from '../../types';

const logger = Logger.getLogger('fetchCityGuide');

const NAMESPACE = 'ACTIONS/FETCH_CITY_GUIDE';

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(NAMESPACE, SLICE_NAMESPACE);

function fetchCityGuide(localeAwareCityGuideId, region, city, transMode, locale) {
    return async function(dispatch) {
        let error = null;

        dispatch(actions.startWork(localeAwareCityGuideId));

        try {
            const { result } = await getCityGuide({
                locale,
                region,
                city,
                transMode,
            });
            dispatch(cityGuideActions.setPlaceGuideContent(result, localeAwareCityGuideId));
            return result;
        } catch (ex) {
            logger.error('fetch', ex, {
                city,
                locale,
                localeAwareCityGuideId,
                region,
                transMode,
            });

            error = {
                code: ex.code,
                message: 'set city guide failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareCityGuideId, undefined, error));
        }
    };
}

const fetchCityGuideSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_CITY_GUIDE';
    },
};

const fetchCityGuideAction = {
    fetchCityGuide,
    ...fetchCityGuideSelectors,
};

export {
    fetchCityGuideAction,
    NAMESPACE as namespace,
};

export default {
    [NAMESPACE]: reducer,
};
